import React, { useRef, useState } from 'react'
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import ProductFormVariantRow from './ProductFormVariantRow'



const cssStyles = props => ({
  root: css`
    width: 100%;
    position: relative;
  `,
  sectionHeader: css`
    display: flex;
    justify-content: space-between;
  `,
  headerTitle: css`
    font-size: 18px;
    font-weight: 500;
  `,
  headerButton: css`
    color: blue;
    cursor: pointer;
  `,
  variantFields: css`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 20px;
    margin-bottom: 10px;
  `,
  buttonContainer: css`
    display: flex;
    gap: 10px;
  `,
  button: css`
    background-color: #000;
    color: #fff;
    margin-top: 5px;
    margin-bottom: 15px;
    font-size: 12px;
    height: 40px;
    width: 75px;
    
    &:hover {
      background-color: #000;
    }
  `,
  variantsSection: css`
    width: 100%;
    margin-top: 35px;
    margin-bottom: 15px;
  `
})




const ProductFormVariants = props => {

  const styles = cssStyles()

  const variantRef = useRef()
  const optionsRef = useRef()

  const [showFields, setShowFields] = useState(false)
  
  const [variantError, setVariantError] = useState(false)
  const [optionsError, setOptionsError] = useState(false)

  const { variants, setFieldValue } = props



  function createVariant() {
    const variant = variantRef.current.value
    const options = optionsRef.current.value

    if (!variant || variant === '') {
      setVariantError('Field can\'t be blank')
      return
    }


    if (!options || options === '') {
      setOptionsError('Field can\'t be blank')
      return
    }


    const optionsArray = options.split(',').map(option => option.trim()) 

    setFieldValue('variants', { ...variants, [variant]: optionsArray })

    variantRef.current.value = ''
    optionsRef.current.value = ''

    setOptionsError(false)
    setVariantError(false)
  }



  function handleClick() {
    setShowFields(true)
  }



  function cancel() {
    setShowFields(false)
  } 



  function handleVariantChange(e) {
    if (!variantError) return

    const variant = e.target.value

    if (!variant || variant === '') {
      setVariantError('Field can\'t be blank')
    } else {
      setVariantError(false)
    }
  }



  function handleOptionsChange(e) {
    if (!optionsError) return

    const options = e.target.value

    if (!options || options === '') {
      setOptionsError('Field can\'t be blank')
    } else {
      setOptionsError(false)
    }
  }



  return (
    <div css={ styles.root }>
      <div>
        <div css={ styles.sectionHeader } >
          <Typography css={ styles.headerTitle }>
            Variants
          </Typography>

          <Typography css={ styles.headerButton } onClick={ handleClick }>
            + Create New Variant
          </Typography>
        </div>


        { showFields && 
            <div css={ styles.variantFields }>
              <TextField
                inputRef={ variantRef }
                variant='outlined'
                name='variant'
                label='Variant'
                placeholder='Size, Color, Material...'
                fullWidth
                error={ Boolean(variantError) }
                helperText={ variantError }
                onChange={ handleVariantChange }
              />


              <TextField
                inputRef={ optionsRef }
                variant='outlined'
                name='options'
                label='Variant Options'
                placeholder='S, M, L, XL'
                helperText={ 
                  optionsError || 
                  'Enter each option separated by a comma e.g. red, blue, green, orange'
                }
                fullWidth
                error={ Boolean(optionsError) }
                onChange={ handleOptionsChange }
              />


              <div css={ styles.buttonContainer }>
                <Button css={ styles.button } onClick={ createVariant }>
                  Create
                </Button>

                <Button css={ styles.button } onClick={ cancel }>
                  Cancel
                </Button>
              </div>
            </div>
        }
      </div>


      <div css={ styles.variantsSection }>
        { Object.keys(variants).map((variant, index) => (
            <ProductFormVariantRow
              key={ variant }
              variant={ variant }
              variants={ variants }
              options={ variants[variant] } 
              setFieldValue={ setFieldValue }
            />
        ))}
      </div>
    </div>
  )
}


export default ProductFormVariants


